import React, { useEffect, useState } from "react";
import { FaTwitter } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  ApprovaledlListLayout,
  ApprovaledlListBody,
  ApprovaledlListRow,
  ApprovaledlListRowKu,
  ApprovaledlListRowOfHead,
  ButtonContainer,
} from "./ApprovaledList.style.js";
import FW from "../../config/word.json";
import { RED } from "../../styles/color";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../components/Layouts/Main/MainLayout.index.js";
import {
  LoadingSpinner,
  LoadingOverlay,
  SmallButtonForReject,
  SmallButtonForDetail,
  colorButtonStyle,
} from "../../styles/common.js";
import {
  getAllProInfoByAuthFlg,
  updateUserFromApproval,
} from "../../api/project";
import Modal from "react-modal";

// ⬇️ xlsx と file-saver をインポート
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function ApprovaledlList(props) {
  const threespace = "　　　";
  const onespace = "　";
  const navigate = useNavigate();

  const [tasks, setTasks] = useState([]);
  const [modalIsOpenForReject, setModalIsOpenForReject] = useState(false);
  const [currentTask, setCurrentTask] = useState({});
  const [reloadEffect, setReloadEffect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedUserFlg] = useState({});

  const [filterUserFlg, setFilterUserFlg] = useState("");
  const [filterTwitterName, setFilterTwitterName] = useState("");
  const [filterEmail, setFilterEmail] = useState("");

  const handleDetailClick = (item) => {
    navigate(`/register?userId=${item.user_id}`);
  };

  useEffect(() => {
    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      navigate("/");
    }
    getAllProInfoByAuthFlg("1")
      .then((res) => {
        setTasks(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [reloadEffect, navigate]);

  const handleApproveForReject = async () => {
    closeModalForReject();
    setLoading(true);
    await updateTaskForReject(currentTask);
    setLoading(false);
    resetState();
  };

  const updateTaskForReject = async (task) => {
    const jUser = {
      userId: task.user_id,
      email: task.email,
      userName: task.user_name,
      userFlg: selectedUserFlg[task.user_id],
      authFlg: "3",
    };
    try {
      const res = await updateUserFromApproval(jUser);
      if (res.code === 200) {
        navigate("/ApprovalList");
      }
    } catch (err) {
      console.error(err);
    }
    await new Promise((resolve) => setTimeout(resolve, 1000));
  };

  const openModalForReject = (task) => {
    setCurrentTask(task);
    setModalIsOpenForReject(true);
  };

  const closeModalForReject = () => {
    setModalIsOpenForReject(false);
  };

  const resetState = () => {
    setCurrentTask({});
    setReloadEffect((prev) => !prev);
  };

  const TwitterIcon = () => <FaTwitter />;

  // コピーボタン用の状態管理
  const [copiedItems, setCopiedItems] = useState({});

  const DEEP_LINK_URL = process.env.REACT_APP_DEEP_LINK_URL;

  // DeepLink URLをコピーする関数
  const handleCopyDeepLink = async (userName, userId) => {
    try {
      const params = new URLSearchParams({
        myproname: userName || "",
      });
      // DeepLink URLの生成
      const deeplinkUrl = `${DEEP_LINK_URL}${params.toString()}`;

      // クリップボードにコピー
      await navigator.clipboard.writeText(deeplinkUrl);

      // コピー成功状態を設定
      setCopiedItems((prev) => ({
        ...prev,
        [userId]: true,
      }));

      // 3秒後にリセット
      setTimeout(() => {
        setCopiedItems((prev) => ({
          ...prev,
          [userId]: false,
        }));
      }, 3000);

      // ログ出力（オプション）
      console.log("コピーしたURL:", deeplinkUrl);
      toast.success("URLをコピーしました");
    } catch (error) {
      console.error("クリップボードへのコピーに失敗しました:", error);
      toast.error("コピーに失敗しました");
    }
  };

  // 🔍 フィルター後の配列
  const filteredTasks = tasks.filter((item) => {
    const matchUserFlg =
      filterUserFlg === "" || item.user_flg === filterUserFlg;
    const matchTwitter =
      filterTwitterName === "" ||
      (item.twitter_name || "")
        .toLowerCase()
        .includes(filterTwitterName.toLowerCase());
    const matchEmail =
      filterEmail === "" ||
      (item.email || "").toLowerCase().includes(filterEmail.toLowerCase());
    return matchUserFlg && matchTwitter && matchEmail;
  });

  // ⬇️ Excel出力処理
  const handleExportToExcel = () => {
    const worksheetData = filteredTasks.map((item) => ({
      Twitter名: item.twitter_name,
      ユーザーID: item.user_id,
      表示名: item.user_name,
      メールアドレス: item.email,
      種別:
        item.user_flg === "1"
          ? "プロ"
          : item.user_flg === "2"
            ? "ゲスト"
            : item.user_flg === "3"
              ? "雀荘"
              : item.user_flg === "4"
                ? "麻雀BAR"
                : "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "承認済ユーザ一覧");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "承認済ユーザ一覧.xlsx");
  };

  return (
    <MainLayout>
      <ApprovaledlListLayout>
        <ApprovaledlListBody>
          <div
            style={{
              marginBottom: "10px",
              textAlign: "left",
              color: "#008000",
            }}
          >
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              {FW.F_W_HOME_ApprovaledList}
            </span>
          </div>

          {/* 絞り込み条件 */}
          <div
            style={{
              marginBottom: "10px",
              textAlign: "left",
              color: "#666",
              fontStyle: "italic",
            }}
          >
            <span style={{ fontSize: "13px", fontWeight: "normal" }}>
              絞り込み条件
            </span>
          </div>

          {/* 🔍 フィルターUI */}
          <div
            style={{
              marginBottom: "20px",
              display: "flex",
              gap: "20px",
              alignItems: "center",
              flexWrap: "wrap",
              padding: "15px",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              border: "1px solid #eaeaea",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <label style={{ fontWeight: "bold", minWidth: "60px" }}>
                種別：
              </label>
              <select
                value={filterUserFlg}
                onChange={(e) => setFilterUserFlg(e.target.value)}
                style={{
                  padding: "6px 12px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              >
                <option value="">すべて</option>
                <option value="1">プロ</option>
                <option value="2">ゲスト</option>
                <option value="3">雀荘</option>
                <option value="4">麻雀BAR</option>
              </select>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <label style={{ fontWeight: "bold", minWidth: "60px" }}>
                <FaTwitter style={{ marginRight: "4px" }} />：
              </label>
              <input
                type="text"
                value={filterTwitterName}
                onChange={(e) => setFilterTwitterName(e.target.value)}
                placeholder="例: 麻雀太郎"
                style={{
                  padding: "6px 12px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <label style={{ fontWeight: "bold", minWidth: "80px" }}>
                E-Mail：
              </label>
              <input
                type="text"
                value={filterEmail}
                onChange={(e) => setFilterEmail(e.target.value)}
                placeholder="例: example@mail.com"
                style={{
                  padding: "6px 12px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
              <button
                onClick={() => {
                  setFilterUserFlg("");
                  setFilterTwitterName("");
                  setFilterEmail("");
                }}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#f0f0f0",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                クリア
              </button>

              <button
                onClick={handleExportToExcel}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#4CAF50",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Excel出力
              </button>
            </div>
          </div>

          {/* 承認済一覧の件数表示 */}
          <div
            style={{
              marginBottom: "10px",
              padding: "8px 12px",
              backgroundColor: "#e8f4fd",
              borderRadius: "4px",
              borderLeft: "4px solid #2196F3",
            }}
          >
            <span
              style={{ fontSize: "13px", fontWeight: "normal", color: "#333" }}
            >
              承認済一覧 📊 全データ：{tasks.length} 件 ／ フィルター結果：
              {filteredTasks.length} 件
            </span>
          </div>

          {/* ヘッダー */}
          <ApprovaledlListRowOfHead>Twitter名前／ID</ApprovaledlListRowOfHead>
          <ApprovaledlListRowOfHead>
            {threespace}雀活マスター表示名前
          </ApprovaledlListRowOfHead>
          <ApprovaledlListRowOfHead>
            {threespace}
            {threespace}E-Mail
          </ApprovaledlListRowOfHead>
          <ApprovaledlListRowOfHead>
            {threespace}
            {threespace}プロ／ゲスト
          </ApprovaledlListRowOfHead>

          {loading && (
            <LoadingOverlay>
              <LoadingSpinner />
            </LoadingOverlay>
          )}

          {/* フィルター後の一覧 */}
          {filteredTasks.map((item) => (
            <ApprovaledlListBody key={item.user_id}>
              <ApprovaledlListRow>
                <TwitterIcon />
                <span style={{ marginLeft: "4px" }}>{item.twitter_name}／</span>
                <a
                  href={`https://x.com/${item.user_id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#1DA1F2", textDecoration: "none" }}
                >
                  {item.user_id}
                </a>
              </ApprovaledlListRow>

              <ApprovaledlListRow>
                {threespace}
                <button
                  onClick={() =>
                    handleCopyDeepLink(item.user_name, item.user_id)
                  }
                  style={{ marginLeft: "0px" }}
                >
                  📋
                </button>
                {item.user_name}
              </ApprovaledlListRow>

              <ApprovaledlListRow>
                {threespace}
                {threespace}
                <a
                  href={`mailto:${item.email}`}
                  style={{ color: "#666", textDecoration: "none" }}
                >
                  {item.email}
                </a>
              </ApprovaledlListRow>

              <ApprovaledlListRow>
                {onespace}
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    marginRight: "1x",
                  }}
                >
                  <input
                    type="radio"
                    name={`userFlg_${item.user_id}`}
                    value="1"
                    checked={item.user_flg === "1"}
                    readOnly
                    style={{ marginRight: "1px" }}
                  />
                  プロ
                </span>

                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    marginRight: "1px",
                  }}
                >
                  <input
                    type="radio"
                    name={`userFlg_${item.user_id}`}
                    value="2"
                    checked={item.user_flg === "2"}
                    readOnly
                    style={{ marginRight: "1px" }}
                  />
                  ゲスト
                </span>

                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    marginRight: "1px",
                  }}
                >
                  <input
                    type="radio"
                    name={`userFlg_${item.user_id}`}
                    value="3"
                    checked={item.user_flg === "3"}
                    readOnly
                    style={{ marginRight: "1px" }}
                  />
                  雀荘
                </span>

                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    marginRight: "1px",
                  }}
                >
                  <input
                    type="radio"
                    name={`userFlg_${item.user_id}`}
                    value="4"
                    checked={item.user_flg === "4"}
                    readOnly
                    style={{ marginRight: "1px" }}
                  />
                  麻雀BAR
                </span>

                <SmallButtonForReject onClick={() => openModalForReject(item)}>
                  解除
                </SmallButtonForReject>

                <SmallButtonForDetail onClick={() => handleDetailClick(item)}>
                  詳細
                </SmallButtonForDetail>
              </ApprovaledlListRow>

              <ApprovaledlListRowKu />
            </ApprovaledlListBody>
          ))}
        </ApprovaledlListBody>
      </ApprovaledlListLayout>

      {/* モーダル */}
      <Modal
        isOpen={modalIsOpenForReject}
        onRequestClose={closeModalForReject}
        contentLabel="雀活マスター否認"
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            maxWidth: "500px",
            width: "90%",
            padding: "20px",
            borderRadius: "8px",
            border: "1px solid #ccc",
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
        }}
      >
        <div>
          <h3 style={{ marginBottom: "15px", color: "#333" }}>
            雀活マスター利用権限の解除
          </h3>

          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "15px",
              borderRadius: "6px",
              marginBottom: "20px",
              borderLeft: "4px solid #f44336",
            }}
          >
            <p style={{ marginBottom: "10px", fontWeight: "bold" }}>
              ◾️ 申込者情報：
            </p>
            <div style={{ marginLeft: "1px" }}>
              <p>・Twitter: {currentTask.twitter_name}</p>
              <p>・表示名: {currentTask.user_name}</p>
              <p>・メール: {currentTask.email}</p>
              <p>
                ・種別:{" "}
                {currentTask.user_flg === "1"
                  ? "プロ"
                  : currentTask.user_flg === "2"
                    ? "ゲスト"
                    : currentTask.user_flg === "3"
                      ? "雀荘"
                      : currentTask.user_flg === "4"
                        ? "麻雀BAR"
                        : ""}
              </p>
            </div>
          </div>

          <div
            style={{
              backgroundColor: "#fff8e1",
              padding: "15px",
              borderRadius: "6px",
              marginBottom: "20px",
              fontSize: "14px",
            }}
          >
            <p
              style={{
                color: "#d32f2f",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              ⚠️ 注意事項
            </p>
            <p>
              利用権限を解除した後、すでに連携済のスケジュール、お気に入りデータが削除されます。
            </p>
          </div>

          <p style={{ marginBottom: "20px", fontWeight: "bold" }}>
            雀活マスターアプリの利用権限を解除しますか？
          </p>
        </div>

        <ButtonContainer
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <button
            onClick={closeModalForReject}
            style={{
              padding: "10px 20px",
              backgroundColor: "#f0f0f0",
              border: "1px solid #ccc",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            いいえ
          </button>
          <button
            style={{
              ...colorButtonStyle(RED),
              padding: "10px 20px",
              borderRadius: "4px",
              border: "none",
              cursor: "pointer",
              color: "white",
            }}
            onClick={handleApproveForReject}
          >
            解除
          </button>
        </ButtonContainer>
      </Modal>
    </MainLayout>
  );
}

export default ApprovaledlList;
